module.exports = __webpack_public_path__ + "img/s6Icon1.a44aa439.png";